import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";

const AppEvent = () => {
  const [list, setList] = useState({});

  const getData = async () => {
    let param = window.location.pathname;
    let eventId = param.match(/\d+/);
    eventId = parseInt(eventId[0]);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_DOMAIN}/app/board/event/${eventId}`
      );
      setList(res.data.data[0]);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Tmp>
      {list?.title ? (
        <Content>
          <Title dangerouslySetInnerHTML={{ __html: list.title }}></Title>
          <hr />
          {/* <img src={list.imageUrl} alt="" /> */}
          <Cont dangerouslySetInnerHTML={{ __html: list.contents }}></Cont>
        </Content>
      ) : null}
    </Tmp>
  );
};
const Tmp = styled.div`
  background-color: white;
  width: 100vw;
  min-width: 100%;
  /* width: 100%; */
  min-height: 100vh;
  height: 100%;
`;
const Content = styled.div`
  padding: 24px 16px;
  /* padding: 240px; */

  word-break: keep-all;
  word-wrap: break-word;

  hr {
    margin: 24px 0px;
    background-color: #e0e0e0;
  }

  a {
    color: #262626;
  }

  img {
    width: 100%;
    max-width: 1200px;
    margin-bottom: 10px;
    object-fit: cover;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
`;

const Cont = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: #262626;
`;
export default AppEvent;
